export enum StockAllocationType {
  IMMEDIATE = 'IMMEDIATE',
  FUTURE = 'FUTURE',
  TRANSPORT = 'TRANSPORT',
  QUOTA = 'QUOTA',
}

export interface StockAllocation {
  type: StockAllocationType;
  quantity: number;
  date?: string;
  quotaId?: string;
  releaseDate?: string; // Data de liberação (para cotas)
}

export interface StockAllocationResult {
  totalRequested: number;
  totalAllocated: number;
  isFullyAllocated: boolean;
  allocations: StockAllocation[];
  message?: string;
}

export interface StockModalData {
  productCode: string;
  productName: string;
  warehouseCode: string;
  channel: '10' | '20';
  currentAllocations?: StockAllocation[]; // Alocações atuais para pré-preencher
}
